import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    height: "40px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    padding: "5px 15px",
    width: "100%",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    height: "40px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    padding: "5px 15px",
    width: "100%",
  },
}));

export default function SubmitButton(props) {
  const { buttonDisabled, handleSubmit, children } = props;

  const classes = useStyles();

  return (
    <Button
      disabled={buttonDisabled}
      className={
        buttonDisabled ? classes.submitButtonDisabled : classes.submitButton
      }
      onClick={() => {
        handleSubmit();
      }}
    >
      {children}
    </Button>
  );
}

SubmitButton.propTypes = {
  inputTitle: PropTypes.any,
};
